var userinfo = {
  set(ui) {
    localStorage.setItem("Commerge_Shipping_Acct", JSON.stringify(ui));
  },
  get() {
    return JSON.parse(localStorage.getItem("Commerge_Shipping_Acct"));
  },
  remove() {
    localStorage.removeItem("Commerge_Shipping_Acct");
  },
};

export default userinfo;
